module.exports = __webpack_public_path__ + "static/media/chevron-down-circle.7594a9b0.svg";